<template>
  <div class="fin-slider">
    <fin-scroll-carousel :items="selections"
                         :selected="value"
                         class="d-flex justify-center flex-wrap">
      <template #default="{item}">
        <div>
          <v-card :class="`${item.content.class} btn-choice ma-3 px-3 ${value === item.id ? 'selected':''}`"
                  :height="cardHeight"
                  :style="'margin:' + cardMargin + 'px; background-color: #FFFFFF'"
                  :width="cardWidth"
                  class="pa-3"
                  @mouseleave="hoverIndex = -1"
                  @mouseover="hoverIndex = item.id"
                  @mouseover.native="hoverIndex = item.id"
                  @mouseleave.native="hoverIndex = -1"
                  @click.prevent="()=>onCardClick(item.id)">
            <v-icon v-if="value === item.id"
                    class="icon-check"
                    style="color: white; background-color: #02073a; border-radius: 50%; position: absolute; right: -10px; top:-14px; font-size: 22px; padding: 3px;"></v-icon>
            <v-row
              align="center"
            >
              <v-col class="pa-0">
                <v-scale-transition>
                  <div class="card-content pa-4">
                    <v-img v-if="item.content.image"
                           :height="cardHeight / 2"
                           :src="item.content.image"
                           :width="cardWidth - 2*20"
                           contain/>
                    <p v-if="item.content.title" class="content-title mt-5">{{ item.title }}</p>
                    <p v-if="item.content.text" :class="['content-text mt-5', {'no-word-break' : noWordBreak}]">
                      {{ item.content.text }}</p>
                  </div>
                </v-scale-transition>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </template>
    </fin-scroll-carousel>
  </div>
</template>

<script>
import FinScrollCarousel from "@/components/common/ScrollCarousel"

export default {
  name: 'fin-slider',
  components: {FinScrollCarousel},
  data() {
    return {
      hoverIndex: -1
    }
  },
  props: {
    /** selected value*/
    value: {
      type: Number
    },
    /** contents of the cards */
    contents: {
      type: Array
    },
    /** Slider's maximal width */
    maxWidth: {
      type: Number,
      default: 900
    },
    /** Card's height */
    cardHeight: {
      type: Number,
      default: 384
    },
    /** Card's width */
    cardWidth: {
      type: Number,
      default: 290
    },
    cardMargin: {
      type: Number,
      default: 16
    },
    noWordBreak: {
      type: Boolean
    }
  },
  methods: {
    onCardClick(n) {
      this.$emit('input', n)
    }
  },
  computed: {
    selections() {
      return this.contents.map((content, index) => ({content, id: index}))
    },
    carouselItemWidth() {
      return 275
    },
    carouselHeight() {
      return 420
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";


.content-title {
  font-size: 1.1em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
}

.content-text {
  font-size: 1em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 19.6px;
  letter-spacing: normal;
}

.btn-choice {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-radius: 0;
  padding: 0;
  margin: 0;
  background-color: #ffffff;
  border: 2px solid transparent;

  &:hover {
    box-shadow: $fin-color-card-shadow;
    -webkit-box-shadow: $fin-color-card-shadow;
    border: 2px solid rgba(2, 7, 58, 0.05) !important;
  }

  &.selected {
    border: 3px solid $fin-color-primary-dark !important;

    .v-icon {
      display: flex;
    }

  }

  p {
    font-size: 16px;
  }

}

.no-word-break {
  hyphens: none;
}

::v-deep .v-slide-group.v-item-group {
  .v-slide-group__next, .v-slide-group__prev {
    min-width: 26px !important;

    .v-icon {
      font-size: 40px;
      color: $fin-color-primary-dark !important;
    }

  }

  .v-slide-group__prev--disabled .v-icon {
    color: $fin-color-light-blue-gray !important;
  }


  .v-slide-group__next--disabled .v-icon {
    color: $fin-color-light-blue-gray !important;
  }
}

/* https://github.com/vuetifyjs/vuetify/issues/10673 */
::v-deep .v-slide-group__wrapper {
  touch-action: pan-y !important;
}
</style>
